import {config} from '../config';

export default {
    getIsDebug: () => config.data.logs.isDebug,
    getIsLogsVisible: () => config.data.logs.isLogsVisible,
    getLogLevel: () => config.data.logs.logLevel,
    getAntdWarningsEnabled: () => config.data.antdWarningsEnabled,
};
